/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Discomfort_OpenInputs */

const en_us2_swap_discomfort_open = /** @type {(inputs: Swap_Discomfort_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Pain and limitations`)
};

const pt_br2_swap_discomfort_open = /** @type {(inputs: Swap_Discomfort_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir Dores e limitações`)
};

const es_419_swap_discomfort_open = /** @type {(inputs: Swap_Discomfort_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir Dolores y limitaciones`)
};

const pt_pt2_swap_discomfort_open = /** @type {(inputs: Swap_Discomfort_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir Dores e limitações`)
};

const fr_fr2_swap_discomfort_open = /** @type {(inputs: Swap_Discomfort_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir Douleurs et limitations`)
};

const de_de2_swap_discomfort_open = /** @type {(inputs: Swap_Discomfort_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schmerzen und Einschränkungen öffnen`)
};

const it_it2_swap_discomfort_open = /** @type {(inputs: Swap_Discomfort_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri Dolori e limitazioni`)
};

/**
* | output |
* | --- |
* | "Open Pain and limitations" |
*
* @param {Swap_Discomfort_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_discomfort_open = /** @type {((inputs?: Swap_Discomfort_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Discomfort_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_discomfort_open(inputs)
	if (locale === "es-419") return es_419_swap_discomfort_open(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_discomfort_open(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_discomfort_open(inputs)
	if (locale === "de-DE") return de_de2_swap_discomfort_open(inputs)
	if (locale === "it-IT") return it_it2_swap_discomfort_open(inputs)
	return en_us2_swap_discomfort_open(inputs)
});
export { swap_discomfort_open as "swap.discomfort_open" }